"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoMarkerLinkProperty = exports.videoMarkerLinkPropertyDefinition = void 0;
exports.videoMarkerLinkPropertyDefinition = {
    name: 'video-marker-link',
    type: 'one-of-container',
    multiple: false,
    view: { label: 'Link' },
    constraints: [
        {
            name: 'oneOfProperties',
            argument: ['video-marker-link-external-link', 'video-marker-link-asset'],
        },
    ],
};
const isVideoMarkerLinkProperty = (prop) => {
    return prop.name === exports.videoMarkerLinkPropertyDefinition.name;
};
exports.isVideoMarkerLinkProperty = isVideoMarkerLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tbWFya2VyLWxpbmsucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy92aWRlby1tYXJrZXItbGluay5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRSxtQkFBbUI7SUFDekIsSUFBSSxFQUFFLGtCQUFrQjtJQUN4QixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUU7SUFDdkIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsaUJBQWlCO1lBQ3ZCLFFBQVEsRUFBRSxDQUFDLGlDQUFpQyxFQUFFLHlCQUF5QixDQUFDO1NBQ3pFO0tBQ0Y7Q0FDOEIsQ0FBQTtBQUkxQixNQUFNLHlCQUF5QixHQUFHLENBQUMsSUFBa0IsRUFBbUMsRUFBRTtJQUMvRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsseUNBQWlDLENBQUMsSUFBSSxDQUFBO0FBQzdELENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9